module.exports = __webpack_public_path__ + "img/icon16.bf932150.png";